<template>
    <div class="creative">
        <swiper>
            <swiper-slide class="creative-tiny" v-for="(item, index) in creative" :key="index">
                <img :src="item" alt="" srcset="">
            </swiper-slide>
        </swiper>
        <InnerTitle :list="titles" @action="actionFunc" :active="active"></InnerTitle>
        <GlobalTitlte :En="titles[active].sub_category_name" :Zh="$t(titles[active].category_name)"
            class=" global-margin global-inner">
            <template #right>
                <div class="gloabl-title-right">
                    <!-- {{ $t("home.i2") }} -->
                </div>
            </template>
        </GlobalTitlte>
        <p class="global-margin  global-inner desc" v-if="titles[active].desc">{{ titles[active].desc }}</p>
        <div :class="[swidth > 768 ? 'flex' : '', 'flex-wrap creativeWords global-margin  global-inner mb-40']"
            v-loading="loading">
            <NormalWithWords v-for="(item, index) in list" :key="index" :photo="item.cover_img"
                :shade="swidth > 768 ? 'hover' : 'always'" :alt="item.category_name"
                :class="[swidth > 1024 ? 'creative-pc-words' : swidth > 768 && swidth <= 1024 ? 'creative-mid-words' : 'creative-m-words']"
                :id="item.id" @setIndex="getItem" :showDefaultWords="swidth > 768 ? true : false" :showWords="true"
                :needJump="false">
                <template #words>
                    <div v-if="swidth > 768" class="pc-bg">
                        <div class="create-inner">
                            <div class="words">
                                <div class="title home-case-title">{{ item.category_name }}</div>
                                <div class="time">{{ item.sub_category_name }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="shade-bg" v-else>
                        <div class="create-inner">
                            <div class="words">
                                <div class="title home-case-title">{{ item.category_name }}</div>
                                <div class="time">{{ item.sub_category_name }}</div>
                            </div>
                        </div>
                    </div>
                </template>
            </NormalWithWords>
        </div>
        <el-empty class="m-auto" description="暂无数据" :image-size="swidth > 768 ? 200 : 100"
            v-show="!list.length"></el-empty>
        <MaskContent :visible="showmask" :swidth="swidth" :mask-closable="true" :center="true" @close="handleClose"
            :innerData="innerData">
            <div class="relative" @click.stop>
                <swiper :options="swiperOptionThumbs" ref="swiper" v-if="innerData.length > 0">
                    <swiper-slide class="creative-inner-tiny" v-for="(item, index) in innerData" :key="index">
                        <img :src="item.img" :alt="item.title" srcset="">
                        <p class="title">{{ item.title }}</p>
                        <p class="content">{{ item.desc }}</p>
                    </swiper-slide>
                </swiper>
                <div :class="[swidth > 768 ? 'mt-60p' : 'mt-12p', 'box-top']" v-if="innerData.length > 1">
                    <div style="color: orangered" class="swiper-button-prev" @click="prev">
                        <i class="el-icon-arrow-left"></i>
                    </div>
                    <div style="color: orangered" class="swiper-button-next" @click="next">
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </div>
                <el-empty class="m-auto" description="暂无数据" :image-size="swidth > 768 ? 200 : 100"
                    v-show="!innerData.length"></el-empty>
            </div>
        </MaskContent>
    </div>
</template>
<script>
import NormalWithWords from "../components/NormalWithWords";
import GlobalTitlte from '../components/GlobalTitlte.vue'
import InnerTitle from '../components/InnerTitle.vue';
import ImageTitle from "../components/ImageTitle.vue";
import MaskContent from "../components/MaskContent.vue";


import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
    components: {
        NormalWithWords,
        GlobalTitlte,
        InnerTitle,
        ImageTitle,
        MaskContent,
        swiper, swiperSlide
    },
    props: {
        swidth: {
            type: Number
        }
    },
    data() {
        return {
            swiperOptionThumbs: {
                loop: true,
                touchRatio: 0.2,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev ",
                },
            },
            titles: [],
            creative: [],
            lang: localStorage.getItem("333f-locale-lang") || "zh_cn",
            wordsList: [
                {
                    pic: require("@/assets/images/solution1.png"),
                    title: this.$t("solution.i1"),
                    words: [
                        this.$t("solution.i2"),
                        this.$t("solution.i3"),
                        this.$t("solution.i4"),
                    ],
                },
                {
                    pic: require("@/assets/images/solution2.png"),
                    title: this.$t("solution.i5"),
                    words: [
                        this.$t("solution.i6"),
                        this.$t("solution.i7"),
                        this.$t("solution.i8"),
                    ],
                },
            ],
            typeList: [],
            page: 1,
            page_size: 12,
            total: 0,
            active: 0,
            category_id: '',
            loading: true, showmask: false,
            innerData: [],
            list: [],
        };
    },
    mounted() {
        this.getBannerImg()
        this.getTypeList(0)
    },
    methods: {
        prev() {
            this.$refs.swiper.swiper.slidePrev()
        },
        next() {
            this.$refs.swiper.swiper.slideNext()
        },
        getBannerImg() {
            this.$http.get('/common/category/getList', {
                pid: 0,
                lang_code: this.lang,
                'to-tree': 0
            }).then((res) => {
                if (res.code == 200) {
                    res.data.map(item => {
                        if (item.id === Number(sessionStorage.getItem('333f-now-tab'))) {
                            this.creative = [item.banner_url]
                        }
                    })
                    // this.titles = res.data;
                }
            });
        },
        getItem(id) {
            this.showmask = true
            this.$http.get("/api/creativity/pageList", {
                page: 1,
                per_page: 999,
                category_id: id
            }).then((res) => {
                if (res.code == 200) {
                    this.innerData = res.data.data
                    if (res.data.data.length < 2) {
                        this.swiperOptionThumbs.loop = false
                    }
                } else {
                    this.loading = false
                    // this.$message.error(res.msg);
                }
            });
        },
        handleClose() {
            this.innerData = []
            this.showmask = false
        },
        actionFunc(item, index) {
            this.list = []
            this.getList(index)
        },
        getList(active) {
            this.active = active
            this.list = this.titles[active].children
            this.loading = false
        },
        getTypeList(active) {
            this.loading = true
            this.$http.get('/common/category/getList', {
                pid: 13,
                lang_code: this.lang,
                'to-tree': 1
            }).then((res) => {
                if (res.code == 200) {
                    this.titles = res.data;
                    this.getList(active)
                } else {
                    this.loading = false
                    // this.$message.error(res.msg);
                }
            });
        },
        getCreateData(page = 1, category_id, index) {
            this.page = page
            this.category_id = category_id
            this.loading = true
            this.$http.get("/api/creativity/pageList", {
                page: this.page,
                per_page: this.page_size,
                category_id: category_id
            }).then((res) => {
                if (res.code == 200) {
                    this.wordsList = res.data.data;
                    this.loading = false
                    this.active = index
                    this.total = res.data.total
                } else {
                    this.loading = false
                    // this.$message.error(res.msg);
                }
            });
        },
        handleCurrentChange(page) {
            this.getCreateData(page, this.category_id, this.active)
        }
    },
};
</script>
<style scoped lang="less">
.creative {
    .creative-tiny {
        img {
            width: 100%;
            height: fit-content;
            min-height: 380px;
        }
    }

    .creative-inner-tiny {
        color: #666;
        padding: 0 5px;
        width: 100% !important;

        img {
            width: 100%;
            height: fit-content;
            // min-height: 380px;
        }


        .title {
            font-size: 30px;
            padding-bottom: 10px;
            padding-top: 10px;
        }

        .content {
            color: #999;
            font-size: 20px;
        }
    }

    .type-list {
        color: @text-defauft-color;
        font-size: 26px;
        margin: 20px 0;

        .all {
            line-height: 1;
            text-align: center;
            min-width: 120px;
            min-height: 120px;
            border-radius: 5px;
            margin-right: 10px;

            p {
                text-align: center;
                line-height: 36px;
                letter-spacing: 2px;
            }
        }

        .all-m {
            line-height: 1;
            text-align: center;
            width: 100%;
            height: 56px;
            border-radius: 5px;
            margin-right: 10px;
            margin-bottom: 20px;

            p {
                text-align: center;
                line-height: 36px;
                letter-spacing: 2px;
            }
        }

        .items {
            font-size: 20px;

            ul {
                li {
                    text-align: center;
                    background-color: #fff;
                    line-height: 36px;
                    white-space: nowrap;
                }

            }
        }

        // .active {
        //     background: @primaryColor;
        //     color: #fff;
        // }
    }

    .active {
        background-color: @primaryColor !important;
        color: #fff;
        border-radius: 3px;
    }

    .desc {
        color: @text-defauft-color;
        line-height: 24px;
        padding: 12px 0 40px;
        font-size: 18px;
        font-weight: 300;
    }

    // .solution-creative {
    //     display: flex;
    //     flex-wrap: wrap;
    //     margin-top: 20px;
    .creative-pc-words {
        width: 33%;
        margin: 0 .5% 6px 0;

        &:nth-child(3n) {
            margin-right: 0;
        }
    }

    .creative-mid-words {
        width: 49%;
        margin: 0 2% 20px 0;

        &:nth-child(2n) {
            margin-right: 0;
        }
    }

    .creative-m-words {
        margin: 0 auto 20px;
        width: 96%;
        min-height: 300px;

        /deep/ img {
            min-height: 300px;
        }

        .shade-words {

            /deep/ .zh,
            /deep/ .en {
                color: @primaryColor !important;
            }
        }
    }

    .creative-inner {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

        .words {
            padding: 0 62px;
            font-size: 16px;
            font-weight: normal;
            color: #fff;

            .title {
                text-align: center;
                font-weight: 500;
                font-size: 32px;
                color: @primaryColor;
                font-family: Arial-BoldMT;
                white-space: break-spaces;
                margin-bottom: 10px;
            }

            .time {
                // text-align: center;
                font-size: 18px;
                margin-bottom: 5px;
            }
        }
    }

    .w-14 {
        width: 14%;
    }

    .w-130 {
        width: 130px;
    }

    .shade-bg {
        padding: 30px;
        width: 100%;
        height: 100%;

        // background-color: @primaryColor !important;
        .title {
            text-align: center;
            font-weight: 500;
            font-size: 36px;
            color: @primaryColor;
            font-family: Arial-BoldMT;
            // white-space: nowrap;
            margin-bottom: 10px;
        }
    }

    .pc-bg {
        width: 100%;
        height: 100%;
        padding: 20px;
        background-color: @primaryColor !important;

        .title {
            text-align: center;
            font-weight: 500;
            font-size: 20px;
            color: #fff;
            font-family: Arial-BoldMT;
            // white-space: nowrap;
            margin-bottom: 10px;
        }

    }

    .create-inner {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        white-space: break-word;

        .words {
            padding: 0 52px;
            font-size: 16px;
            font-weight: normal;
            color: #fff;
            width: 100%;


            .time {
                text-align: center;
                // white-space: nowrap;
                margin-bottom: 5px;
            }
        }
    }

    .swiper-button-prev,
    .swiper-button-next {
        border-radius: 50%;
        font-size: 40px;


    }

    .swiper-button-prev,
    .swiper-container-rtl .swiper-button-next {
        background-image: none;
        left: 0;
    }

    .swiper-button-next,
    .swiper-container-rtl .swiper-button-prev {
        background-image: none;
        // right: 0;
    }

}

.box-top {
    width: 100%;
    // height: 30px;
    position: absolute;
    display: flex;
    justify-content: space-between;
    top: 30%;
    left: 0;
    right: 0;
}

@media (max-width: 900px) {
    .creative-tiny {
        img {
            height: 400px !important;
            object-fit: cover;
        }
    }

    .creative-inner-tiny {
        img {
            height: auto !important;
            max-height: 400px;
        }
    }
}

@media screen and (max-width: 768px) {
    .box-top {
        top: 25%;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/creativeInteraction.vue